import { useState } from "react";

export default function TestPage() {
    const [clicked, setClicked] = useState(false);

    return (
        <div
            className={`relative inline-block px-6 py-2 text-cyan-500 border-2 border-transparent transition-colors duration-300 ${
                clicked ? "text-cyan-500 border-cyan-500" : ""
            }`}
            onClick={() => setClicked(true)}
        >
            <span
                className={`absolute top-0 left-0 h-full w-full transition-all duration-500 pointer-events-none ${
                    clicked ? "border-t-2 border-r-2 border-cyan-500" : "border-transparent"
                }`}
            ></span>
            <span
                className={`absolute bottom-0 right-0 h-full w-full transition-all duration-500 delay-500 pointer-events-none ${
                    clicked ? "border-b-2 border-l-2 border-cyan-500" : "border-transparent"
                }`}
            ></span>
            Click Me
        </div>
    );
}
